<template>
    <div>
        <SectionsPrivacySection1/>
    </div>
</template>

<script setup>
    useHead({
        bodyAttrs: {
            class: "navbar-dark scheme-emerge"
        },
    })
</script>